export default {
  fragments: {},
  header: true,
  footer: true,
  admin: false,
  doSignup: false,
}
